/**
 * Reads a case number from a URL segment. Links pasted from chat or email often pick up trailing
 * characters, so the leading digits win: "2880**" → 2880, "2880)" → 2880, "abc" → null.
 */
export const parseCaseId = (segment: string | undefined): number | null => {
  const digits = segment?.match(/^\d+/)?.[0];
  return digits ? Number(digits) : null;
};
